export enum ResponsibleCompanyEnum {
  confiax = 'REDE_CONFIAX',
  vistorias = 'REDE_VISTORIAS'
}
